import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { CookieService } from "ngx-cookie-service";
import { interval, Observable, Subject } from "rxjs";
import { switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class LayoutService {
  private subject = new Subject<any>();
  pageTitle: string;

  api_url = environment.baseIP + environment.apiPrefix;
  selectedLeadContacts;
  access_token: any;
  options: any;

  constructor(
    private http: HttpClient,
    private _cookieService: CookieService
  ) {
    this.access_token = this._cookieService.get("access_token");
    this.options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.access_token,
      }),
    };
  }

  userName: string;
  setUserFullName(fullName: string) {
    this.userName = fullName;
  }

  getUserFullName() {
    return this.userName;
  }

  setContentTitle(title: string) {
    this.subject.next({ text: title });
  }

  getContentTitle() {
    return this.subject.asObservable();
  }

  //new api
  getOrganizationById(id: number): Observable<any> {

    const params = new HttpParams().set('id', id.toString());

    return this.http.get<any>(
      `${this.api_url}/organization/view`,
      { params }
    );
  }

  //reminder set

  pollReminders(organizationId: any): Observable<any> {
    const headers = new HttpHeaders({
      organizationId: organizationId.toString(),
      Authorization: 'Bearer ' + this.access_token,
      'Content-Type': 'application/json'
    });
    return interval(30000).pipe( // every 30 seconds
      switchMap(() => this.http.post(
        `${this.api_url}call-log/reminders`,
        null, //body
        {
          headers, //options
        }
      ))
    );
  }

  callLogMarkReminderDone(organizationId: number,
    payload: any): Observable<any> {
    const headers = new HttpHeaders({
      organizationId: organizationId.toString(),
      Authorization: 'Bearer ' + this.access_token
    });

    // const params = new HttpParams()
    //   .set('status_id', call_log_id.toString());

    return this.http.post(
      `${this.api_url}call-log/mark-reminder-done`,
      payload,                 // ✅ NO BODY
      { headers }
    );
  }
}
